function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import MobileTabs from "segments/desktop/core-components/mobile-tabs/mobile-tabs";
import { useState } from "react";
import MobileTabNavButton from "segments/desktop/core-components/mobile-tabs/mobile-tab-nav-button";
import BuildingBlocksTabContentComponent from "../building-blocks-tab-content/building-blocks-tab-content-component";
import { StyledBuildingBlocksTabsMobileComponent } from "./building-blocks-tabs-mobile-component.scss";
const BuildingBlocksTabsMobileComponent = (props)=>{
    const { buildingBlocksTabsTheme, customNavigationItemRenderer, defaultSelectedTabIndex = 0, displayContentTitle = false } = props;
    const [selectedTab, setSelectedTab] = useState(defaultSelectedTabIndex);
    const [wasComponentEverVisible, setWasComponentEverVisible] = useState(false);
    const defaultNavigationItemRenderer = (tab, index, isSelected = false)=>{
        return /*#__PURE__*/ _jsx(MobileTabNavButton, {
            label: tab.tabLabel,
            selected: isSelected,
            theme: buildingBlocksTabsTheme
        });
    };
    const navigationItemRenderer = customNavigationItemRenderer || defaultNavigationItemRenderer;
    const carouselItemRenderer = (tab, index)=>{
        const isSelected = index === selectedTab;
        // bring the first asset on load, and bring everything else when component is visible
        const isAssetVisible = wasComponentEverVisible || isSelected;
        return /*#__PURE__*/ _jsx(BuildingBlocksTabContentComponent, {
            tab: tab,
            isAssetVisible: isAssetVisible,
            buildingBlocksTabsTheme: buildingBlocksTabsTheme,
            themeColor: buildingBlocksTabsTheme,
            isMobileDisplay: true,
            displayTitle: displayContentTitle
        }, index);
    };
    return /*#__PURE__*/ _jsx(StyledBuildingBlocksTabsMobileComponent, {
        className: "building-blocks-tabs-mobile-component",
        children: /*#__PURE__*/ _jsx(MobileTabs, _object_spread_props(_object_spread({}, props), {
            selectedTab: selectedTab,
            setSelectedTab: setSelectedTab,
            wasComponentEverVisible: wasComponentEverVisible,
            setWasComponentEverVisible: setWasComponentEverVisible,
            navigationItemRenderer: navigationItemRenderer,
            carouselItemRenderer: carouselItemRenderer
        }))
    });
};
export default BuildingBlocksTabsMobileComponent;
